import APIClient from '../../../lib/api';

class ProjectService {
  async getAll(params = {}) {
    const defaultParams = {
      skip: 0,
      limit: 50
    };
    
    const queryParams = { ...defaultParams, ...params };
    
    try {
      const response = await APIClient.projects.getAll(queryParams);
      return {
        success: true,
        data: response.data.data || response.data,
        total: response.data.total || response.data.length
      };
    } catch (error) {
      console.error('ProjectService.getAll Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης projects'
      };
    }
  }

  async getById(projectId) {
    try {
      const response = await APIClient.projects.getById(projectId);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('ProjectService.getById Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης project'
      };
    }
  }

  async create(projectData) {
    try {
      const response = await APIClient.projects.create(projectData);
      return {
        success: true,
        data: response.data,
        message: 'Το project δημιουργήθηκε επιτυχώς'
      };
    } catch (error) {
      console.error('ProjectService.create Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα δημιουργίας project'
      };
    }
  }

  async update(projectId, updateData) {
    try {
      const response = await APIClient.projects.update(projectId, updateData);
      return {
        success: true,
        data: response.data,
        message: 'Το project ενημερώθηκε επιτυχώς'
      };
    } catch (error) {
      console.error('ProjectService.update Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα ενημέρωσης project'
      };
    }
  }

  async delete(projectId) {
    try {
      await APIClient.projects.delete(projectId);
      return {
        success: true,
        message: 'Το project διαγράφηκε επιτυχώς'
      };
    } catch (error) {
      console.error('ProjectService.delete Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα διαγραφής project'
      };
    }
  }

  formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('el-GR');
  }

  getStatusColor(status) {
    const statusColors = {
      active: 'success',
      inactive: 'warning',
      completed: 'primary',
      cancelled: 'error'
    };
    return statusColors[status] || 'default';
  }

  getTypeIcon(projectType) {
    const typeIcons = {
      website: '🌐',
      web_application: '💻',
      other: '📁'
    };
    return typeIcons[projectType] || '📁';
  }

  getTypeLabel(projectType) {
    const typeLabels = {
      website: 'Website',
      web_application: 'Web Application',
      other: 'Άλλο'
    };
    return typeLabels[projectType] || 'Άλλο';
  }
}

const projectService = new ProjectService();
export default projectService;